const defaultOptions: SortOptions[] = [
  'popular',
  'name',
  'volatility',
  'hitRatio',
  'rtp',
];

const liveGameOptions: SortOptions[] = ['popular', 'name', 'rtp'];

const liveRtpOptions: SortOptions[] = [
  'popular',
  'rtpLivePastDay',
  'rtpLivePastSevenDays',
  'rtpLivePastThirtyDays',
];

export default function getSortOptions(
  isLiveRtp?: boolean,
  isLiveGameCategory?: boolean,
): SortOptions[] {
  if (isLiveRtp) {
    return liveRtpOptions;
  }
  if (isLiveGameCategory) {
    return liveGameOptions;
  }
  return defaultOptions;
}
